import React, { useState } from 'react';
import { Space, Popover } from 'antd';
import ToggleIcon from '@icons/common/toggle.svg';
import Toggles from './Toggles';
import Panels from './Panels';
import Admin from './Admin';
import { isAppModule } from '@src/utils/constants';
import { checkIsAdminUser, checkIsInternalUser } from '@src/globalStore/profileStore';
import { SectionWrapper, StyledDivider } from './styled';
import { ToggleButton } from '@src/components/common/Utils/Buttons';
import Actions from './Actions';
import { checkFeature } from '@src/utils/platform/features/checkFeature';
import LatchSave from './LatchSave';
import DimensionViews from './DimensionViews';

const Content = () => {
  const isAdmin = checkIsAdminUser();
  const isInternal = checkIsInternalUser();
  const enableAdminAction = isAdmin && isInternal && isAppModule;
  return (
    <Space direction="vertical">
      <SectionWrapper>
        <div>
          <Panels />
        </div>
        <StyledDivider type="vertical" />
        <div>
          <Toggles />
        </div>
        <StyledDivider type="vertical" />
        <div>
          <DimensionViews />
        </div>
        <StyledDivider type="vertical" />
        <div>
          <Actions />
        </div>
        {enableAdminAction && (
          <>
            <StyledDivider type="vertical" />
            <div>
              <Admin />
            </div>
          </>
        )}
      </SectionWrapper>
    </Space>
  );
};

function OptionsPopover() {
  const [open, setOpen] = useState(false);

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  return (
    <Space wrap style={{ marginLeft: 10 }}>
      <Popover
        content={<Content />}
        title=""
        trigger="click"
        placement="bottomRight"
        styles={{ body: { paddingLeft: 20 } }}
        zIndex={900}
        getPopupContainer={(trigger) => (trigger.parentNode as HTMLElement) || document.body}
        open={open}
        onOpenChange={handleOpenChange}
      >
        <ToggleButton icon={<ToggleIcon />} />
      </Popover>
    </Space>
  );
}

function More() {
  return checkFeature('trends.base.options_popover', true) ? (
    <>
      <LatchSave />
      <OptionsPopover />
    </>
  ) : (
    <></>
  );
}

export default More;
